import { render, staticRenderFns } from "./OCLink.html?vue&type=template&id=6e73df56&scoped=true&"
import script from "./OCLink.ts?vue&type=script&lang=ts&"
export * from "./OCLink.ts?vue&type=script&lang=ts&"
import style0 from "./OCLink.css?vue&type=style&index=0&id=6e73df56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e73df56",
  null
  
)

export default component.exports